import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";

import sentrisLogo from "src/images/logo.png";

const LogoWrapper = styled(Link)(
  ({ theme }) => `
    color: ${theme.palette.text.primary};
    padding: 0px;
    display: flex;
    font-weight: ${theme.typography.fontWeightBold};
    text-align: center;
    flex: 1;
    justify-content: center;
`
);

function Logo() {
  return (
    <LogoWrapper to="/dashboards">
      <img src={sentrisLogo} width={50} alt="logo" />
    </LogoWrapper>
  );
}

export default Logo;
